
	import Vue from "vue"
	import Component from "vue-class-component"
	import ContentHeader from "custom/ContentHeader.vue"
	import Page from "custom/Page.vue"
	import PageSlide from "@components/container/PageSlide.vue"
	import Products from "custom/portfolio/Products.vue"
	import Customers from "custom/portfolio/Customers.vue"
	import Secured from "utils/security/Secured"
	import { session } from "api/index"
	import IcsIcon from "custom/ui/IcsIcon.vue"
	import { Ref, Watch } from "vue-property-decorator"
	import PNavigationTabs from "@portal-components/ui/navigation/PNavigationTabs.vue"
	import PNavigationTabItem from "@portal-components/ui/navigation/PNavigationTabItem.vue"
	import { Product } from "api/models/products"
	import productClient from "api/clients/product-client"
	import toaster from "custom/utils/toaster"
	import { CompanyOverviewModel } from "api/models/company"
	import companyClient from "api/clients/company-client"
	import { authenticationModule } from "store/modules"

	@Secured(session)
	@Component({
		components: {
			ContentHeader,
			PNavigationTabs,
			PNavigationTabItem,
			Page,
			PageSlide,
			Products,
			Customers,
			IcsIcon
		}
	})
	export default class Portfolio extends Vue {
		@Ref() readonly portfolioTabs!: PNavigationTabs
		@authenticationModule.Getter loggedIn!: boolean

		readonly translationKey = "portfolio"

		products: ReadonlyArray<Product> = []
		customers: ReadonlyArray<CompanyOverviewModel> = []
		permissions: ReadonlyArray<any> = []
		loading = false

		@Watch("loggedIn", { immediate: true })
		loggedInChanged(): Promise<void> | void {
			if (this.loggedIn) {
				this.setActiveTab()

				this.loading = true
				return productClient.getProducts()
					.then(async products => {
						this.products = products
						this.customers = await companyClient.getCompanies()
						this.permissions = await companyClient.getPermissions()
					})
					.catch(() => toaster.error({ title: "general.error" }))
					.finally(() => this.loading = false)
			}
		}

		private setActiveTab(): void {
			const urlParams = new URLSearchParams(window.location.search)
			const tabKey = urlParams.get("tab")

			if (tabKey === null) {
				return
			}

			this.portfolioTabs.setActiveTab(tabKey)
		}
	}
